import MaleIcon from "../../assets/GenderLogo/Male.svg";
import UnspecifiedIcon from "../../assets/GenderLogo/Unspecified.svg";
import FemaleIcon from "../../assets/GenderLogo/Female.svg";
import ReactCountryFlag from "react-country-flag";
import { countries } from "countries-list"; // Import the countries list
export const GenderLogos = {
  male: MaleIcon,
  female: FemaleIcon,
  unspecified: UnspecifiedIcon,
};
export const getGenderLogo = (gender) => {
  let genderValue = gender ? String(gender)?.trim()?.toLowerCase() : null;
  switch (genderValue) {
    case "male":
      return GenderLogos[genderValue];
    case "female":
      return GenderLogos[genderValue];
    case "unspecified":
      return GenderLogos[genderValue];
    default:
      return GenderLogos["unspecified"];
  }
};
export const getCountryLogo = (countryName, style, pathName) => {
  let countryValue = countryName
    ? String(countryName)?.trim()?.toLowerCase()
    : null;
  if (countryValue) {
    // Get ISO code for the given country name
    const countryCode = Object.keys(countries)?.find((key) =>
      countryValue?.includes(countries[key]?.name?.toLowerCase())
    );
    // Check if countryCode is found
    if (!countryCode) {
      return "";
    }
    return (
      <ReactCountryFlag
        countryCode={countryCode}
        svg
        style={
          style
            ? style
            : pathName === "dashboard"
            ? { width: "4.5rem", height: "3.5rem", marginRight: "0.5rem" }
            : { width: "4.5rem", height: "3.5rem", marginRight: "0.5rem" }
        }
      />
    );
  } else {
    return "";
  }
};
